import React from 'react';
import PropTypes from 'prop-types';
import { getShootingChartOptions } from './getShootingChartOptions';

import useChart from '../../hooks/useChart';
import { round1Display } from '../../lib/format';

const PlayerViewShooting = ({ player }) => {
  const options = getShootingChartOptions({ player });
  const chart = useChart(options);

  return (
    <div className="s-player-view__shooting--container">
      <div className="s-player-view__shooting--chart" ref={chart} />
      <div className="s-player-view__shooting">
        <div className="overflow-allowed">
          <table>
            <thead>
              <tr>
                <th colSpan="2"></th>
                <th colSpan="4" style={{ backgroundColor: '#ffe0b2' }}>
                  Overall
                </th>
                <th colSpan="4" style={{ backgroundColor: '#c8e6c9' }}>
                  Rim
                </th>
                <th colSpan="4" style={{ backgroundColor: '#f8bbd0' }}>
                  Mid
                </th>
                <th colSpan="4" style={{ backgroundColor: '#E1BEE7' }}>
                  2P
                </th>
                <th colSpan="4" style={{ backgroundColor: '#bbdefb' }}>
                  3P
                </th>
              </tr>
              <tr>
                <th colSpan="2">Season</th>
                <th>FGM</th>
                <th>FGA</th>
                <th>FG%</th>
                <th>ASTD%</th>
                <th>FGM</th>
                <th>FGA</th>
                <th>FG%</th>
                <th>ASTD%</th>
                <th>FGM</th>
                <th>FGA</th>
                <th>FG%</th>
                <th>ASTD%</th>
                <th>FGM</th>
                <th>FGA</th>
                <th>FG%</th>
                <th>ASTD%</th>
                <th>FGM</th>
                <th>FGA</th>
                <th>FG%</th>
                <th>ASTD%</th>
              </tr>
            </thead>
            <tbody>
              {player.shooting.map(row => (
                <tr>
                  <td colSpan="2" className="label double">
                    {row.name}
                  </td>
                  <td>{row.fgm}</td>
                  <td>{row.fga}</td>
                  <td>{round1Display(row.fg_perc)}%</td>
                  <td>{round1Display(row.astd_perc_fg)}%</td>
                  <td>{row.atr}</td>
                  <td>{row.atra}</td>
                  <td>{round1Display(row.atr_perc)}%</td>
                  <td>{round1Display(row.astd_perc_atr)}%</td>
                  <td>{row.mid}</td>
                  <td>{row.mida}</td>
                  <td>{round1Display(row.mid_perc)}%</td>
                  <td>{round1Display(row.astd_perc_mid)}%</td>
                  <td>{row.fgm2}</td>
                  <td>{row.fga2}</td>
                  <td>{round1Display(row.fg2_perc)}%</td>
                  <td>{round1Display(row.astd_perc_two)}%</td>
                  <td>{row.fgm3}</td>
                  <td>{row.fga3}</td>
                  <td>{round1Display(row.fg3_perc)}%</td>
                  <td>{round1Display(row.astd_perc_three)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

PlayerViewShooting.propTypes = {
  player: PropTypes.object.isRequired,
};

export default PlayerViewShooting;
